/**
 * The app's languages (founder, 2026-10-08): One28's five plus Japanese,
 * Greek, Portuguese (Brazilian wording) and Dutch. Admin stays English.
 *
 * `READY` is what the app actually offers. A language joins it only when its
 * file is complete (src/i18n/i18n.test.ts enforces that) and the request cards
 * have been re-measured in it (CLAUDE.md, request-card text contract).
 * Until then a phone set to that language simply gets English.
 */
export const LANGUAGES = [
  { code: "en", name: "English" },
  { code: "fr", name: "Français" },
  { code: "es", name: "Español" },
  { code: "de", name: "Deutsch" },
  { code: "it", name: "Italiano" },
  { code: "ja", name: "日本語" },
  { code: "el", name: "Ελληνικά" },
  { code: "pt", name: "Português" },
  { code: "nl", name: "Nederlands" },
] as const;

export type Lang = (typeof LANGUAGES)[number]["code"];

export const READY: readonly Lang[] = ["en", "fr", "es", "de", "it", "pt", "nl", "el"];

/**
 * Which language to show: the viewer's own choice if it is still offered,
 * else the first of the phone's / browser's languages we offer, else English.
 * Region is ignored ("pt-PT" and "pt-BR" both get "pt").
 */
export function pickLanguage(
  saved: string | null,
  preferred: readonly string[],
  ready: readonly Lang[] = READY,
): Lang {
  const offered = (code: string): code is Lang => (ready as readonly string[]).includes(code);
  if (saved && offered(saved)) return saved;
  for (const tag of preferred) {
    const base = tag.toLowerCase().split(/[-_]/)[0];
    if (offered(base)) return base;
  }
  return "en";
}
